import { render, staticRenderFns } from "./DonutChart64.vue?vue&type=template&id=4518e756&scoped=true"
import script from "./DonutChart64.vue?vue&type=script&lang=js"
export * from "./DonutChart64.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4518e756",
  null
  
)

export default component.exports